// extracted by mini-css-extract-plugin
export default {"project-details-container":"ProjectDetail_project-details-container__zyPg5"};